import { UUID } from '@macs-frontend/core/utils/uuid';
import {
  AbstractLocation,
  Email,
  Phone,
  ActionLocation,
} from '@macs-frontend/web-macs/shared';
import { ContactClient, ContactSupplier } from './client';
import { ClientUser } from '@macs-frontend/features/shared/models/user.model';

export interface BaseContact {
  uuid: UUID;
  firstName: string;
  lastName: string;
  birthDate: string;
  contactPhotoFilename: string;
  roleLabel: string;
  status: ContactStatuses;
}

export interface ContactClientUser {
  uuid: UUID;
  clientUuid: UUID;
}

export interface Contact extends BaseContact {
  clientRoles: ContactClient[];
  supplierRoles: ContactSupplier[];
  phones: Phone[];
  emails: Email[];
  contactLocations: ContactLocation[];
  clientUsers: Record<string, ContactClientUser>;
  hasRelatedClientUser: boolean;
}

export enum ContactStatuses {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum ContactsSortTypes {
  Name = 'name',
  Client = 'client',
  Supplier = 'supplier',
  Email = 'email',
  Phone = 'phone',
  Locations = 'locations',
}

export interface ContactLocation extends AbstractLocation {}
